<template>
  <div>
    <div class="card mb-4" @click="$emit('modalImage')" style="cursor:zoom-in;" aria-hidden="true">
      <img :src="produto.url_imagem ? produto.url_imagem : base_cdn + '/static/imgs/default.png'"
           class="img-detalhes"/>
    </div>
    <div>
      <h2 class="h5 m-0">{{produto.nome_produto}}</h2>
      <div v-if="produto.tabelas.length === 1 && produto.tabelas[0].principal === '0'">({{produto.tabelas[0].nome_tabela}})</div>
      <p class="m-0 text-muted" v-if="produto.descricao_produto" v-html="produto.descricao_produto"></p>
    </div>
    <div class="my-2" v-if="produto.tabelas.length === 1">
      <div class="alert alert-warning d-flex align-items-center" v-if="produto.tabelas[0].estoque === '1' && produto.tabelas[0].qtd_estoque <= 0">
        <i class="fa fa-warning mr-2"></i>
        <div>
          <h6 class="mb-0 font-weight-bold">Sem estoque</h6>
          <p class="small mb-0 text-muted">Este produto está indisponível no momento</p>
        </div>
      </div>
      <div class="alert alert-warning d-flex align-items-center" v-else-if="!['1','5','6'].includes(produto.tabelas[0].tipo_consumo)">
        <i class="fa fa-info-circle mr-2"></i>
        <div>
          <h6 class="mb-0 font-weight-bold">Disponibilidade</h6>
          <div class="small" v-if="produto.tabelas[0].turnos">Horário permitido das {{produto.tabelas[0].turnos}} horas.</div>
          <div class="small" v-else>Disponível {{ produto.tabelas[0].tipo_consumo | tipo_consumo }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CardInfo from "./CardInfo";
  import ProdutoConsumo from "./ProdutoConsumo";
  export default {
    name: "ProdutoDescricao",
    components: {ProdutoConsumo, CardInfo},
    props: ['produto'],
    filters: {
      tipo_consumo(tipo) {
        switch (tipo) {
          case '2':
            return 'apenas para retirar no local';
          case '3':
            return 'apenas para entregas';
          case '4':
            return 'apenas para consumo no local';
          case '5':
            return 'para retiradas e entregas';
          case '6':
            return 'para retiradas e consumo no local';
        }
      }
    }
  }
</script>

<style scoped>
  .card-img {
    border-radius: 16px;
    border: none;
    overflow: hidden;
  }

  .img-detalhes {
    width: 100%;
    height: 220px;
    object-fit: cover;
    object-position: center;
  }
</style>
